<template>
  <div>
    <el-table height="calc(100vh - 360px)" :data="auditList">
      <el-table-column prop="userId" label="用户ID"> </el-table-column>
      <el-table-column prop="emial" label="邮箱"> </el-table-column>
      <el-table-column prop="tel" label="手机号"> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            @click="cancelBlack(scope.row)"
          >
            解除限制
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import Pagination from "components/pagination";
import { mapGetters, mapMutations, mapState, mapActions } from "vuex";
export default {
  name: "KYCAudit",
  data() {
    return {
      auditId: null,
    };
  },
  methods: {
    ...mapActions("authLimit", ["list", "deleteLimit"]),
    cancelBlack({ userId }) {
      this.$confirm("确认将此用户解除限制吗？", "提示", {
        type: "warning",
      }).then(() => {
        this.deleteLimit({ userId }).then((res) => {
          if (res.code == 0) {
            this.$message({
              type: "success",
              message: "操作成功！",
            });
            // this.list();
            this.$emit("refresh");
          }
        });
      });
    },
  },
  computed: {
    ...mapState("authLimit", ["auditList"]),
  },
};
</script>

<style lang="less" scoped></style>
